import React from "react";

interface LoadingSpinnerProps {
  size?: "small" | "medium" | "large";
  message?: string;
  fullScreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message,
  size = "medium",
  fullScreen = false,
}) => {
  return (
    <div
      className={
        fullScreen ? "loading-spinner-fullscreen" : "loading-spinner-container"
      }
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={message || "Loading content"}
    >
      <div className={`loading-spinner-${size}`} aria-hidden="true"></div>
      {message && (
        <p className="loading-spinner-message" aria-hidden="false">
          {message}
        </p>
      )}
      <span className="sr-only">{message || "Loading content"}</span>
    </div>
  );
};
